import styles from "./styles.module.scss";

export const Notification = ({children}) => {
  return <div className={styles.notification}>{children}</div>;
};
